export let spanish =
    {
        "Home":"Inicio",
        "MyAccount":"Mi cuenta",
        "WatchLater":"Favoritos",
        "VideoOnDemand":"Vídeo a la carta",
        "Notifications":"Notificaciones",
        "History":"Historia",
        "AllCategories":"Todas las categorías",
        "TVSeries":"Series de Televisión",
        "Movie":"Película",
        "Documentaries":"Documentales",
        "ViewAll":"Ver todos",
        "Rate":"Puntuación",
        "Autoplay":"Auto-reproducción",
        "RelatedVideos":"Videos Relacionados",
        "Play":"Reproducir",
        "Director":"Director",
        "Writer":"Escritor",
        "About":"Sobre",
        "PrivacyPolicy":"Política de Privacidad",
        "Term&Conditions":"Términos y Condiciones",
        "Search":"Buscar",
        "Cancel":"Cancelar",
        "NoVideosAddedToWatchLaterYet":"Ningún Video Añadido Para Ver Más Tarde",
        "Addyourfavoritevideostoaccessandwatcheasilywithoutanyhassles":"Agrega tus videos favoritos para poder verlos fácilmente y sin problemas.",
        "ExploreVideos":"Explora más videos",
        "SayHelloToTheFutureofMobiletainment":"Di HOLA al Futuro del Entretenimiento Digital",
        "AllWatchLater":"Todos los favoritos",
        "ShowMore":"Mostrar más",
        "Clear":"Eliminar",
        "NoHistoryVideosYet": "Sin historial de videos todavía",
        "AccountDetails":"Cuenta Detalles",
        "Name":"Nombre",
        "EmailAddress":"Correo electrónico",
        "Location":"Localización",
        "Interests":"Intereses",
        "Choose3Categories":"Elige tus preferencias",
        "Sports":"Deportes",
        "Action":"Acción",
        "Adventure":"Aventura",
        "Fitness":"Fitness",
        "Entertainment":"Entretenimiento",
        "GeneralSettings":"Ajustes generales",
        "AccountType":"Tipo de cuenta",
        "Premium":"Premium",
        "Timezone":"Zona horaria",
        "EditPhoto":"Editar foto",
        "Save":"Guardar",
        "Profiledetailsaved":"Datos de perfil guardados",
        "Successfullyaddedtoyourwatchlater":"Añadido correctamente a tu lista de ver más tarde",
        "Successfullyremovedfromyourwatchlater":"Eliminado correctamente de tu lista de ver más tarde",
        "Watchwithnolimits":"Ve videos sin límite",
        "Standard":"Estándar",
        "ShowLess":"Muestra menos",
        "Namecannotbeempty":"El nombre no puede estar vacío",
        "EmailAddresscannotbeempty":"La dirección de correo electrónico no puede estar vacía",
        "EmailAddressisnotvalid":"La dirección de correo electrónico no es válida, ingrese una dirección de correo electrónico adecuada",
        "Locationcannotbeempty":"La ubicación no puede estar vacía",
        "Profilepicturesaved":"Imagen de perfil guardada",
        "PlayDisable":"No disponible en demostración"
    }



// WEBPACK FOOTER //
// ./src/constants/spanish.js